import { render, staticRenderFns } from "./LessonThumb.vue?vue&type=template&id=108c4e66&scoped=true&"
import script from "./LessonThumb.vue?vue&type=script&lang=js&"
export * from "./LessonThumb.vue?vue&type=script&lang=js&"
import style0 from "./LessonThumb.vue?vue&type=style&index=0&id=108c4e66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108c4e66",
  null
  
)

export default component.exports